import { render, staticRenderFns } from "./BowSkeleton.vue?vue&type=template&id=efca8120&"
import script from "./BowSkeleton.vue?vue&type=script&lang=js&"
export * from "./BowSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports